import dayjs, { Dayjs } from 'dayjs';
import { ICaseInformation } from 'us.collection.case/reducers/CaseInformation/Interfaces';
import * as Yup from 'yup';

export const CaseInformationValidator = Yup.object<ICaseInformation>().shape({
    caseDueDate:Yup.string(),
    obsoleteDate: Yup
    .string()
    .when('caseDueDate', (caseDueDate:Dayjs, schema:any) => {
      return schema.test({
        test: (obsoleteDate:Dayjs) => dayjs(obsoleteDate).isAfter(caseDueDate),
        message: 'US.COLLECTION.VALIDATIONS:REQUIRED.MAX_SHOULD_BE_>_MIN'
      })
    }),
    caseDescription:Yup
    .string().max(50,'US.COLLECTION.VALIDATIONS:REQUIRED.CAN_NOT_BE_MORE_THAN_50')
    .nullable(),
    debtwarningDate: Yup
    .string()
    .when(
      ['caseDueDate', 'noOfDaysDueDateToDWDate'], 
      (caseDueDate: string, noOfDaysDueDateToDWDate: number, schema: any) => {
        return schema.test({
          test: (debtwarningDate: string) => {
            const minValidDate = dayjs(caseDueDate).add(noOfDaysDueDateToDWDate, 'days').startOf('day');
            const selectedDate = dayjs(debtwarningDate).startOf('day');
            return selectedDate.isSameOrAfter(minValidDate);
          },
          message: 'US.COLLECTION.VALIDATIONS:REQUIRED.DW_DATE_SHOULD_BE_GREATER_THAN_OR_EQUAL_TO_DUE_DATE_PLUS_DAYS_TO_SEND_DW',
        });
      }
    )
    .nullable(),
  });